import FuseLoading from '@fuse/core/FuseLoading';
import LoadingDialog from 'app/admin/common/LoadingDialog';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Typography, Button, Icon, TextField, Checkbox } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import { useEffect, useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { withRouter, Prompt, useParams, useHistory } from 'react-router-dom';
import _ from '@lodash';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import VizsgazoService from '../service/VizsgazoService';

function VizsgazoSubmitForm(props) {
	const dispatch = useDispatch();
	const history = useHistory();
	const [initStatus, setInitStatus] = useState('loading');
	const [loading, setLoading] = useState(false);
	const [showLeaveConfirmDialog, setShowLeaveConfirmDialog] = useState(false);
	const [lastLocation, setLastLocation] = useState(null);
	const [confirmedNavigation, setConfirmedNavigation] = useState(false);
	//const [data, setData] = useState(null);
	const [formData, setFormData] = useState(null);
	const [colCount, setColCount] = useState(0);
	const theme = useTheme();
	const { examId } = useParams();

	const methods = useForm({
		mode: 'onChange',
		defaultValues: {}
	});
	const { formState, getValues, reset, control, clearErrors, setError } = methods;

	useEffect(() => {
		VizsgazoService.getInputFormData(examId).then(response => {
			setFormData(response);
			setColCount(response.vizsga_helye.length + 1);
			setInitStatus('done');
		});
	}, []);

	useEffect(() => {
		if (formData !== null) {
			const data = {
				vizsgaId: examId,
				csoport: []
			};
			formData.csoport.forEach(cs => {
				formData.vizsga_helye.forEach(vh => {
					data.csoport.push({
						csoport: cs,
						vizsgaHelyeId: vh.id,
						darabszam: null,
						online: false
					});
				});
			});
			reset(data);
		}
	}, [formData]);

	const handleBlockedNavigation = nextLocation => {
		if (!confirmedNavigation && formState.isDirty && Object.keys(formState.dirtyFields).length > 0) {
			console.log('DIRTY FIELDS');
			console.log(formState.dirtyFields);
			setShowLeaveConfirmDialog(true);
			setLastLocation(nextLocation);
			return false;
		}
		return true;
	};

	const handleConfirmNavigationClick = () => {
		setShowLeaveConfirmDialog(false);
		setConfirmedNavigation(true);
	};

	useEffect(() => {
		if (confirmedNavigation && lastLocation) {
			history.push(lastLocation.pathname);
		}
	}, [confirmedNavigation, lastLocation]);

	const handleSave = () => {
		clearErrors();
		const values = getValues();
		setLoading(true);
		VizsgazoService.generateExaminee(values)
			.then(response => {
				setLoading(false);
				if (response.successful) {
					setConfirmedNavigation(true);
					dispatch(showMessage({ message: 'Sikeres mentés.' }));
					history.goBack(history);
				} else {
					const propKeys = Object.keys(response.properties);
					if (propKeys.length > 0) {
						dispatch(showMessage({ message: response.properties[propKeys[0]][0].message }));
					} else {
						dispatch(showMessage({ message: 'Feladatsor nem lezárható, vagy hiba történt.' }));
					}
				}
			})
			.catch(e => {
				setLoading(false);
				dispatch(showMessage({ message: 'Hiba történt.' }));
			});
	};

	return (
		<FormProvider {...methods}>
			<FusePageCarded
				classes={{
					root: initStatus !== 'done' ? 'hidden' : null,
					toolbar: 'p-0',
					header: 'min-h-72 h-72 sm:h-136 sm:min-h-136'
				}}
				header={
					<div className="flex flex-1 w-full items-center justify-between">
						<div className="flex flex-col items-start max-w-full min-w-0">
							<motion.div initial={{ x: 20, opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}>
								<Typography className="flex items-center sm:mb-12" component={Button} role="button" onClick={() => history.goBack(history)} color="inherit">
									<Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
									<span className="hidden sm:flex mx-4 font-medium">Vissza</span>
								</Typography>
							</motion.div>

							<div className="flex items-center max-w-full">
								<div className="flex flex-col min-w-0 mx-8 sm:mc-16">
									<motion.div initial={{ x: -20 }} animate={{ x: 0, transition: { delay: 0.3 } }}>
										<Typography className="text-16 sm:text-20 truncate font-semibold">Vizsgázók felvitele</Typography>
									</motion.div>
								</div>
							</div>
						</div>
						<motion.div className="flex" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}>
							<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" onClick={() => handleSave()} startIcon={<Icon className="hidden sm:flex">save</Icon>}>
								Mentés
							</Button>
						</motion.div>
					</div>
				}
				content={
					<div className="p-16 sm:p-24">
						{formData ? (
							<div className="gap-12 grid" style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr)` }}>
								<div>&nbsp;</div>
								{formData.vizsga_helye.map(vh => (
									<div key={vh.id}>{vh.rovid}</div>
								))}
								{formData.csoport.map((cs, csIndex) => (
									<Fragment key={cs}>
										<div className="flex items-center">{`${cs}. csoport`}</div>
										{formData.vizsga_helye.map((vh, vhIndex) => (
											<div key={`${cs}-${vh.id}`} className='flex flex-row'>
												<Controller
													control={control}
													name={`csoport.${csIndex * formData.vizsga_helye.length + vhIndex}.darabszam`}
													render={({ field, fieldState }) => (
														<TextField
															{...field}
															value={field.value || ''}
															onChange={e => (e.target.value.length > 0 ? field.onChange(e.target.value) : field.onChange(null))}
															variant="outlined"
															type="number"
															size="small"
														/>
													)}
												/>
												<Controller
													control={control}
													name={`csoport.${csIndex * formData.vizsga_helye.length + vhIndex}.online`}
													render={({ field, fieldState }) => (
														<Checkbox
															{...field}
															value={field.value}
															onChange={e =>field.onChange(e.target.checked)}
														/>
													)}
												/>
											</div>
										))}
									</Fragment>
								))}
							</div>
						) : null}
						<Prompt when message={nextLocation => handleBlockedNavigation(nextLocation)} />
						<ConfirmDialog
							show={showLeaveConfirmDialog}
							title="Megerősítés"
							description="Az űrlapon mentetlen adatok vannak, továbblépés esetén ezek elvesznek. Biztosan elhagyod az űrlapot?"
							onYes={() => handleConfirmNavigationClick()}
							onClose={() => setShowLeaveConfirmDialog(false)}
						/>
					</div>
				}
			/>
			{initStatus === 'loading' ? <FuseLoading /> : null}
			{loading && <LoadingDialog content="Vizsgázók felvitele folyamatban" />}
		</FormProvider>
	);
}

export default withRouter(VizsgazoSubmitForm);
